import { axios } from '@/plugins/axios';

export const getNotifications = (params) => axios.get(`/notifications`, {params: params})
  .then(res => res.data);

export const getNotification = (id) => axios.get(`/notifications/${id}`)
  .then(res => res.data);

export const countUnreadedNotifications = () => axios.get(`/notifications/count-unreaded`)
  .then(res => res.data);